export const CONSENT_DECISION = {
  agreed: 'agreed',
  declined: 'declined',
  withdrawn: 'withdrawn',
} as const;

export type ConsentDecision = (typeof CONSENT_DECISION)[keyof typeof CONSENT_DECISION];
